import { filter } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, OnInit } from '@angular/core';
import { HeaderComponent } from './common/header/header.component';
import { FooterComponent } from './common/footer/footer.component';
import { ToggleService } from '../app/common/header/toggle.service';
import { SidebarComponent } from './common/sidebar/sidebar.component';
import {
    CommonModule,
    Location,
    LocationStrategy,
    PathLocationStrategy,
} from '@angular/common';
import {
    RouterOutlet,
    Router,
    NavigationCancel,
    NavigationEnd,
} from '@angular/router';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { VersionCheckService } from './core/services/version-check.service';

@Component({
    selector: 'app-root',
    imports: [
        RouterOutlet,
        CommonModule,
        SidebarComponent,
        HeaderComponent,
        FooterComponent,
        MatSnackBarModule,
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    providers: [
        Location,
        {
            provide: LocationStrategy,
            useClass: PathLocationStrategy,
        },
    ],
})
export class AppComponent implements OnInit {
    title = 'Trinta -  Angular 19 Material Design Admin Dashboard Template';
    routerSubscription: any;
    location: any;

    constructor(
        // eslint-disable-next-line no-unused-vars
        public router: Router,
        // eslint-disable-next-line no-unused-vars
        public toggleService: ToggleService,
        // eslint-disable-next-line no-unused-vars
        @Inject(PLATFORM_ID) private platformId: Object,
        // eslint-disable-next-line no-unused-vars
        private versionCheck: VersionCheckService
    ) {
        this.toggleService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });
    }

    // Toggle Service
    isToggled = false;

    // Dark Mode
    toggleTheme() {
        this.toggleService.toggleTheme();
    }

    // Settings Button Toggle
    toggle() {
        this.toggleService.toggle();
    }

    // ngOnInit
    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.recallJsFuntions();
            this.versionCheck.start();
        }
    }

    // recallJsFuntions
    recallJsFuntions() {
        this.routerSubscription = this.router.events
            .pipe(
                filter(
                    (event) =>
                        event instanceof NavigationEnd ||
                        event instanceof NavigationCancel
                )
            )
            .subscribe((event) => {
                this.location = this.router.url;
                if (!(event instanceof NavigationEnd)) {
                    return;
                }
                this.scrollToTop();
            });
    }
    scrollToTop() {
        if (isPlatformBrowser(this.platformId)) {
            window.scrollTo(0, 0);
        }
    }
}
